module.exports = __webpack_public_path__ + "img/14.b27e86ea.jpg";